<template>
    <v-field :label="label">
        <q-input-frame class="q-input q-if-focusable" :color="color">
            <span v-if="this.value" v-html="this.value" @click="redirect"></span>
        </q-input-frame>
    </v-field>
</template>

<script>
import mixins from './mixins'
import {
    QInputFrame
} from 'quasar-framework'

export default {
    name: 'VLastOrder',
    components: { QInputFrame },
    mixins,

    props: {
        color: {
            type: String,
            default: 'highlight'
        }
    },

    methods: {
        redirect() {
            localStorage.setItem("openModal", this.value);
            this.$router.push({ name: `backoffice.stock-orders` })
        }
    },

    mounted() {
        this.color = this.form['last_order.stock_order_status_id'] == 1 ? 'red' : 'highlight'
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/form/VLastOrder.vue